export default __webpack_public_path__ + "static/media/icons-reports.cccbe331.svg";